export default __webpack_public_path__ + "static/media/lock.ea1bc6c9.svg";